import { VideoSlideItemType, hasVideoSources, isVideoAsset } from '@llx/common';
import { useState } from 'react';

import { VideoLoader } from '@/components/ui/video-loader';

import { BaseSlideProps } from '../../types';
import { getAssetById } from '../../utils/asset-loader';

export const VideoSlide = ({ slide, assets, assetsBaseUrl }: BaseSlideProps) => {
  const [isLoading, setIsLoading] = useState(true);

  // Get the first video item
  const videoItem = slide.items[0] as VideoSlideItemType;
  const videoAsset = getAssetById(videoItem.assetRef, assets);

  if (!videoAsset || !isVideoAsset(videoAsset)) {
    return (
      <div className="flex h-full w-full items-center justify-center p-4">
        <p className="text-lg text-livelinx-grey200">Vidéo non trouvée</p>
      </div>
    );
  }

  // Handle multiple quality sources
  const videoSources = hasVideoSources(videoAsset)
    ? videoAsset.sources.map((source) => ({
        src: `${assetsBaseUrl}${source.path}`,
        type: source.mimeType || 'video/mp4',
      }))
    : [{ src: `${assetsBaseUrl}${videoAsset.path}`, type: 'video/mp4' }];

  return (
    <div className="flex h-full w-full items-center justify-center p-2 sm:p-4 md:p-8">
      <div className="relative aspect-video w-full max-w-4xl overflow-hidden rounded-lg bg-black shadow-white">
        {isLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-black/50">
            <VideoLoader size="large" />
          </div>
        )}
        <video
          controls
          playsInline
          controlsList="nodownload"
          className="h-full w-full object-contain"
          onLoadedData={() => setIsLoading(false)}
          onError={() => setIsLoading(false)}
          preload="metadata"
          autoPlay
        >
          {videoSources.map((source, idx) => (
            <source key={idx} src={source.src} type={source.type} />
          ))}
          Votre navigateur ne supporte pas la lecture vidéo.
        </video>
      </div>
    </div>
  );
};
